import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TituloPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TituloPage",
            ss: ss,
            ajax: {
                "url": ss.indexTitulo(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'NombreTitulado', name: 't.NombreTitulado', title: 'NombreTitulado' },
                { data: 'NumeroRegistroTitulo', name: 't.NumeroRegistroTitulo', title: 'NumeroRegistroTitulo' },
                { data: 'NumeroRegistroDiploma', name: 't.NumeroRegistroDiploma', title: 'NumeroRegistroDiploma' },
                { data: 'Programa', name: 'pr.Programa', title: 'Programa' },
                { data: 'NombreSubPrograma', name: 'pps.NombreSubPrograma', title: ' Sub Programa' },
                { data: 'UnidadAcademica', name: 'ua.UnidadAcademica', title: 'Unidad Académica' },
                { data: 'Gestion', name: 't.Gestion', title: 'Gestion' },
                { data: 'PeriodoGestion', name: 't.PeriodoGestion', title: 'Periodo' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            titulos: [],
            titulo: {},
            personatitulo: {},
            tipomiembros: [],
            puntajes: [],
            isLoading: false,
            unidadacademicas: [],
            programas: [],
            accedeNotas: false,
            notaManual: false,
            errorBag: {}
        };
    },
    methods: {

        getTipoMiembros() {
            this.ss.listTipoMiembro().then(result => {
                let response = result.data;
                this.tipomiembros = response.data;
            })
        },
        getUnidadAcademicas() {
            this.ss.listUnidadAcademica().then(result => {
                let response = result.data;
                this.unidadacademicas = response.data;
            })
        },
        getProgramas() {
            this.ss.listPrograma().then(result => {
                let response = result.data;
                this.programas = response.data;
            })
        },
        newTitulo() {
            this.titulo = {};
            this.$refs['frm-titulo'].show();
        },
        showTitulo(id) {
            this.isLoading = true;
            this.ss.showTitulo(id).then(
                (result) => {
                    let response = result.data;
                    this.titulo = response.data;
                    this.$refs['view-titulo'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        syncTitulo() {
            this.isLoading = true;
            this.ss.syncTitulo().then(
                (result) => {
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    this.$refs['datatable-titulo'].reload();
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        editTitulo() {
            this.$refs['frm-titulo'].show();
            this.$refs['view-titulo'].hide();
        },
        cancelTitulo() {
            if (this.titulo.id) {
                this.$refs['view-titulo'].show();
            }
            this.$refs['frm-titulo'].hide();
        },
        saveTitulo() {
            this.ss.storeTitulo(this.titulo).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-titulo'].hide();
                    this.$refs['datatable-titulo'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTitulo() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTitulo(this.titulo)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-titulo'].hide();
                                this.$refs['datatable-titulo'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        print(option) {
            this.isLoading = true;
            this.ss.printTitulo({ params: { id: this.titulo.id, Tipo: option } })
                .then(result => {
                    let response = result.data;
                    var a = document.createElement("a");
                    a.href = response.data.url;
                    a.target = '_blank';
                    a.click();
                    console.log(a);
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        draw() {
            window.$('.btn-datatable-Titulo').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTitulo(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        this.persona = JSON.parse(localStorage.getItem('persona'));
        if (!this.persona) {
            this.$router.push('/Login');
        } else {
            this.getUnidadAcademicas();
            this.getProgramas();
            this.getTipoMiembros();
        }
    }
};
